import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center pt-24 pb-16 overflow-hidden bg-negro" style={{
    backgroundImage: `url('https://cdn.magicpatterns.com/uploads/oNyCkARkb9zLcAXPDyjaRa/Diseno_sin_titulo_(3).png')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  }} data-id="element-138">
      {/* Dark overlay for text legibility - warm gradient using brand colors */}
      <div className="absolute inset-0" style={{
      background: 'linear-gradient(135deg, rgba(44,42,38,0.85) 0%, rgba(166,61,47,0.65) 50%, rgba(44,42,38,0.9) 100%)'
    }} data-id="element-139"></div>

      {/* Subtle noise texture */}
      <div className="absolute inset-0 bg-noise opacity-50" data-id="element-140"></div>

      <div className="relative z-10 max-w-[1180px] mx-auto px-5 md:px-8 flex flex-col items-center text-center" data-id="element-141">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-block border border-terracota rounded-full px-4 py-1.5 mb-8 bg-negro/30 backdrop-blur-sm" data-id="element-142">
          <span className="text-ambar font-nunito text-xs md:text-sm uppercase tracking-widest font-bold" data-id="element-143">
            Para emprendedores de la Quebrada de Humahuaca
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-4xl md:text-6xl lg:text-7xl font-playfair font-bold text-white leading-tight mb-6 text-balance drop-shadow-lg" data-id="element-144">
          Alguien te está buscando
          <br data-id="element-145" />
          ahora mismo en internet.
          <br data-id="element-146" />
          <span className="text-ambar italic font-normal" data-id="element-147">¿Qué encuentra?</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-arena/90 font-nunito text-lg md:text-xl max-w-[580px] mb-10 leading-relaxed text-balance drop-shadow" data-id="element-148">
          Si tu negocio no se ve como lo que realmente es, estás perdiendo
          clientes todos los días sin darte cuenta.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-149">
          <a href="#contacto" className="bg-terracota text-white px-8 py-3.5 rounded-full font-nunito font-semibold border-2 border-ambar hover:bg-terracota/90 hover:border-white transition-all duration-250 shadow-warm-lg hover:-translate-y-0.5 text-center" data-id="element-150">
            Escribinos por WhatsApp &rarr;
          </a>
          <a href="#servicios" className="border border-arena text-arena px-8 py-3.5 rounded-full font-nunito font-semibold hover:bg-arena/10 transition-all duration-250 text-center backdrop-blur-sm" data-id="element-151">
            Ver servicios
          </a>
        </motion.div>
      </div>

      {/* Bottom curve to transition to next section */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none z-10" data-id="element-152">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-full h-[60px] md:h-[80px]" style={{
        transform: 'rotate(180deg)'
      }} data-id="element-153">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#2C2A26" data-id="element-154"></path>
        </svg>
      </div>
    </section>;
}